(() => {
  const COLLAPSED_ATTR = 'data-collapsed-height';

  const getLeadBlock = (body) => {
    if (!body) return null;
    return body.querySelector(':scope > p') || body.firstElementChild;
  };

  const measureCollapsedHeight = (clip, body) => {
    const lead = getLeadBlock(body);
    if (!lead) return 0;

    const clipTop = clip.getBoundingClientRect().top;
    const leadRect = lead.getBoundingClientRect();
    const marginBottom = parseFloat(window.getComputedStyle(lead).marginBottom) || 0;

    return Math.ceil(leadRect.bottom - clipTop + marginBottom);
  };

  const setCollapsed = (root, collapsed) => {
    const clip = root.querySelector('[data-zaoud-description-clip]');
    const toggle = root.querySelector('[data-zaoud-description-toggle]');
    const moreLabel = root.querySelector('[data-zaoud-description-more]');
    const lessLabel = root.querySelector('[data-zaoud-description-less]');
    if (!clip || !toggle) return;

    root.classList.toggle('is-collapsed', collapsed);
    root.classList.toggle('is-expanded', !collapsed);
    toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');

    if (moreLabel) moreLabel.hidden = !collapsed;
    if (lessLabel) lessLabel.hidden = collapsed;

    if (collapsed) {
      const height = root.getAttribute(COLLAPSED_ATTR);
      if (height) clip.style.maxHeight = `${height}px`;
    } else {
      clip.style.maxHeight = 'none';
    }
  };

  const refresh = (root) => {
    const clip = root.querySelector('[data-zaoud-description-clip]');
    const body = root.querySelector('[data-zaoud-description-body]');
    const toggle = root.querySelector('[data-zaoud-description-toggle]');
    if (!clip || !body || !toggle) return;

    const wasExpanded = root.classList.contains('is-expanded');

    clip.style.maxHeight = 'none';
    root.classList.remove('is-collapsed', 'is-expanded');

    const lead = getLeadBlock(body);
    const siblings = body.children.length;
    const collapsedHeight = measureCollapsedHeight(clip, body);
    const fullHeight = body.scrollHeight;
    const hasMore = Boolean(lead) && (siblings > 1 || fullHeight > collapsedHeight + 2);

    if (!hasMore || collapsedHeight <= 0) {
      root.removeAttribute(COLLAPSED_ATTR);
      toggle.hidden = true;
      clip.style.maxHeight = 'none';
      toggle.setAttribute('aria-expanded', 'false');
      return;
    }

    root.setAttribute(COLLAPSED_ATTR, String(collapsedHeight));
    toggle.hidden = false;
    setCollapsed(root, !wasExpanded);
  };

  const init = (root) => {
    if (!root || root.dataset.zaoudDescriptionReady === 'true') return;
    root.dataset.zaoudDescriptionReady = 'true';

    const toggle = root.querySelector('[data-zaoud-description-toggle]');
    if (toggle) {
      toggle.addEventListener('click', () => {
        const nextCollapsed = root.classList.contains('is-expanded');
        setCollapsed(root, nextCollapsed);
      });
    }

    refresh(root);

    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => refresh(root), 120);
    });
  };

  const boot = (scope = document) => {
    scope.querySelectorAll('[data-zaoud-product-description]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document));
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
